var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisconnecting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        .disconnecting-st0{fill:#FFFFFF;stroke:currentColor;stroke-width:8.2257;stroke-miterlimit:10;}\r\n        .disconnecting-st1{fill:#FFFFFF;stroke:currentColor;stroke-width:8;stroke-miterlimit:10;}\r\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "disconnecting-st0",
    d: "M107.2,169.4l145.3,0.2l10.4,10.4c-4.1,4.1-6.3,6.3-10.4,10.4L107,190.2l-11-11L107.2,169.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "disconnecting-st1",
    d: "M304.5,148c-14,0-26,9-30.3,21.6c-0.1,0.4-0.3,0.9-0.4,1.3l9.1,9.1c-3.6,3.6-5.8,5.8-9.1,9.1 c0.1,0.2,0.1,0.5,0.2,0.7c4.1,12.9,16.2,22.2,30.5,22.2c17.7,0,32-14.3,32-32S322.1,148,304.5,148z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "disconnecting-st1",
    d: "M55.5,212c14,0,26-9,30.3-21.6c0.1-0.4,0.3-0.9,0.4-1.3l-9.1-9.1c3.6-3.6,5.8-5.8,9.1-9.1 c-0.1-0.2-0.1-0.5-0.2-0.7C81.9,157.3,69.8,148,55.5,148c-17.7,0-32,14.3-32,32S37.9,212,55.5,212z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnecting);
export default __webpack_public_path__ + "static/media/disconnecting.4683b4e7f6c6ad7c9283157806d9781c.svg";
export { ForwardRef as ReactComponent };